import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gfu-featured-projects"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_skeleton_card = _resolveComponent("skeleton-card")

  return (!$options.isLessThanL)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (n) => {
          return _createVNode(_component_skeleton_card, { key: n })
        }), 64 /* STABLE_FRAGMENT */))
      ]))
    : (_openBlock(), _createBlock(_component_skeleton_card, {
        key: 1,
        class: "gfu-featured-projects"
      }))
}